var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 221.11 72.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c2c58;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#fff;}.cls-3{fill:#d1a782;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.06,
    y1: 72.61,
    x2: 9.06,
    y2: 50.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1a782"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 30.94,
    y1: 72.64,
    x2: 30.94,
    y2: 50.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 51.65,
    y1: 72.59,
    x2: 51.65,
    y2: 50.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 70.71,
    y1: 72.24,
    x2: 70.71,
    y2: 50.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 96.76,
    y1: 72.59,
    x2: 96.76,
    y2: 50.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 116.93,
    y1: 72.24,
    x2: 116.93,
    y2: 50.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 136.55,
    y1: 72.4,
    x2: 136.55,
    y2: 50.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 153.08,
    y1: 72.24,
    x2: 153.08,
    y2: 50.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 170.68,
    y1: 72.42,
    x2: 170.68,
    y2: 50.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 193.7,
    y1: 72.61,
    x2: 193.7,
    y2: 50.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 213.65,
    y1: 72.59,
    x2: 213.65,
    y2: 50.14,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cost savings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.38,37.57c-1.16.58-3.07-.58-4.34-.29-1.44.33-2.87,2.26-4.35,2.29-1.31,0-2.51-1.84-3.79-2.12-1.44-.32-3.58.81-4.93.2-1.19-.53-1.46-2.73-2.48-3.53S95.9,33.31,95,32.19s-.12-3.08-.69-4.23c-.65-1.32-2.88-2.27-3.24-3.68-.32-1.25,1.25-2.82,1.24-4.11,0-1.46-1.6-3.27-1.3-4.7.26-1.26,2.37-2,2.93-3.16.63-1.32,0-3.63.89-4.79s3-.79,4-1.59,1.59-3.27,2.91-3.93c1.16-.58,3.07.58,4.34.29C107.51,2,108.94,0,110.42,0c1.31,0,2.51,1.84,3.79,2.12,1.45.32,3.58-.81,4.93-.2,1.19.53,1.46,2.73,2.49,3.53s3.58.81,4.54,1.93.11,3.08.68,4.23c.65,1.32,2.88,2.27,3.24,3.68.32,1.25-1.25,2.82-1.24,4.11,0,1.46,1.6,3.27,1.3,4.7-.26,1.26-2.37,2-2.93,3.16-.63,1.32,0,3.63-.89,4.79s-3,.79-4,1.59-1.6,3.27-2.92,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.47,19.79a15.91,15.91,0,1,1-4.66-11.26,15.94,15.94,0,0,1,4.66,11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.47,19.79A13.91,13.91,0,1,1,120.39,10a13.91,13.91,0,0,1,4.08,9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.78,15.62a4.57,4.57,0,0,1,.92-3.13,3.24,3.24,0,0,1,2.52-1,3.29,3.29,0,0,1,2.57,1,4.53,4.53,0,0,1,.93,3.14,4.5,4.5,0,0,1-.93,3.13,3.24,3.24,0,0,1-2.52,1,3.3,3.3,0,0,1-2.57-1A4.58,4.58,0,0,1,101.78,15.62Zm2.35,0a4,4,0,0,0,.35,2.06.91.91,0,0,0,1.49,0,4.15,4.15,0,0,0,.35-2.06,4.08,4.08,0,0,0-.35-2,.9.9,0,0,0-1.49,0A4,4,0,0,0,104.13,15.6Zm3.39,12.47h-2.23l8.38-16.6h2.17Zm4.87-4.13a4.55,4.55,0,0,1,.93-3.14,3.71,3.71,0,0,1,5.09,0,4.55,4.55,0,0,1,.93,3.14,4.53,4.53,0,0,1-.93,3.14,3.24,3.24,0,0,1-2.52,1,3.31,3.31,0,0,1-2.57-1A4.53,4.53,0,0,1,112.39,23.94Zm2.35,0A4,4,0,0,0,115.1,26a.84.84,0,0,0,.74.4.83.83,0,0,0,.74-.39,4.15,4.15,0,0,0,.35-2.06,4.18,4.18,0,0,0-.34-2.06.86.86,0,0,0-.75-.39.82.82,0,0,0-.74.39A4,4,0,0,0,114.74,23.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.38,72.61q-5.49,0-8.44-2.79T0,61.83a13.29,13.29,0,0,1,1.36-6.21,9.81,9.81,0,0,1,3.87-4.07,11.71,11.71,0,0,1,5.93-1.44,16,16,0,0,1,3.4.37,9.67,9.67,0,0,1,2.75,1,23.35,23.35,0,0,1,.22,5.2h-1.6l-2.11-4.92,2,1.69a10.89,10.89,0,0,0-5-1.21q-6.55,0-6.55,8.82,0,9.46,7.56,9.46a10.22,10.22,0,0,0,5-1.23l-.13,1.28-2.93.26,2.71-5.09h1.69a21.3,21.3,0,0,1-.71,5.53,9.55,9.55,0,0,1-2.73,1A15.19,15.19,0,0,1,11.38,72.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.92,72.64a10.39,10.39,0,0,1-5.45-1.39,9.21,9.21,0,0,1-3.57-3.91,13,13,0,0,1-1.27-6,13.19,13.19,0,0,1,1.27-6,9.2,9.2,0,0,1,3.58-3.92,10.36,10.36,0,0,1,5.46-1.39,10.41,10.41,0,0,1,5.46,1.39A9.23,9.23,0,0,1,40,55.39a13.18,13.18,0,0,1,1.26,6,13.32,13.32,0,0,1-1.26,6,9.26,9.26,0,0,1-3.58,3.92A10.55,10.55,0,0,1,30.92,72.64Zm.57-2.16q5.54,0,5.53-8.3,0-4.8-1.72-7.36a5.56,5.56,0,0,0-4.91-2.57q-5.54,0-5.54,8.3,0,4.81,1.73,7.37A5.56,5.56,0,0,0,31.49,70.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M50.91,72.59a10.44,10.44,0,0,1-6.42-1.84,22.59,22.59,0,0,1-.22-5.43h1.61l2.37,5.51-1.71-1.64a9.84,9.84,0,0,0,4.88,1.34,4.59,4.59,0,0,0,3-.88,3.09,3.09,0,0,0,1-2.49A3,3,0,0,0,54.65,65,6.28,6.28,0,0,0,52,63.58l-2.15-.68q-5.56-1.76-5.56-6.28a5.92,5.92,0,0,1,2.06-4.73,8.34,8.34,0,0,1,5.58-1.75,12,12,0,0,1,5.67,1.32,20.19,20.19,0,0,1,.22,4.76H56.14l-1.93-4.48,2.11,1.8a10.65,10.65,0,0,0-4.88-1.34q-3.59,0-3.58,3.14a3.12,3.12,0,0,0,.86,2.27,7,7,0,0,0,2.81,1.49l2.15.68q5.43,1.71,5.43,6.18a5.89,5.89,0,0,1-2.22,4.84A9.21,9.21,0,0,1,50.91,72.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.33,57a23.5,23.5,0,0,1,.35-6.48l3.4,1.25L62.82,57Zm.74-4.28-.39-2.2H79.74L79,52.69Zm4,19.55.11-1.41q.66-.24,1.47-.45L69.3,70l-.44,1.63V68.55h3.69v3.08l-.41-1.48,3.31.64-.11,1.45Zm2.81-.33V50.8h3.69V71.91ZM78.6,57l-2.27-5.23,3.41-1.25A23.5,23.5,0,0,1,80.09,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96,72.59a10.44,10.44,0,0,1-6.42-1.84,22.59,22.59,0,0,1-.22-5.43H91l2.37,5.51-1.71-1.64a9.84,9.84,0,0,0,4.88,1.34,4.59,4.59,0,0,0,3-.88,3.09,3.09,0,0,0,1-2.49A3,3,0,0,0,99.76,65a6.35,6.35,0,0,0-2.64-1.41L95,62.9q-5.56-1.76-5.56-6.28a5.92,5.92,0,0,1,2.06-4.73,8.34,8.34,0,0,1,5.58-1.75,12,12,0,0,1,5.67,1.32,20.19,20.19,0,0,1,.22,4.76h-1.69l-1.93-4.48,2.11,1.8a10.65,10.65,0,0,0-4.88-1.34Q93,52.2,93,55.34a3.12,3.12,0,0,0,.86,2.27,7,7,0,0,0,2.81,1.49l2.15.68q5.43,1.71,5.43,6.18A5.89,5.89,0,0,1,102,70.8,9.21,9.21,0,0,1,96,72.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.33,50.49l-6.76,20.32-.16-.66,2.68.64L113,72.24h-6.92l.11-1.41a7.69,7.69,0,0,1,1.23-.49,13.17,13.17,0,0,1,1.41-.34l-1,.81L115,50.47Zm-6.21,15.58.72-2.11h9.34l.75,2.11Zm7.53-15.71,7.23,20.45-1-.63,2.88.61-.11,1.45h-8.21l.11-1.49a12.55,12.55,0,0,1,2.61-.77l-.29.61-6.15-18.72-.75-1.4a14.62,14.62,0,0,1,1.76-.14Q117.75,50.32,118.65,50.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M134.91,72.37l-7-20.45,1,.63L126,51.94l.11-1.45h8.48l-.11,1.45a13.52,13.52,0,0,1-2.81.75l.26-.55,6,18.72.48,1.4a13.9,13.9,0,0,1-1.67.14Q135.81,72.41,134.91,72.37Zm1.06-.13,6.59-20.32.2.66-2.95-.64.11-1.45h7.19l-.11,1.4a7.69,7.69,0,0,1-1.23.5,13.17,13.17,0,0,1-1.41.34l1-.81-7,20.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M157.39,50.49l-.11,1.4a19.11,19.11,0,0,1-2.79.86l.44-1.65v3.08h-3.69V51.1l.37,1.48-2.92-.64.11-1.45Zm-8.61,21.75.11-1.41a20.54,20.54,0,0,1,2.79-.85l-.44,1.65V68.55h3.69v3.08l-.37-1.48,2.92.64-.11,1.45Zm2.46-.33V50.8h3.69V71.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M165.39,54.27,162.82,53l-2.92-1,.1-1.45h5.08Zm-5.41,18,.11-1.41a20.54,20.54,0,0,1,2.79-.85l-.44,1.65V68.55h2.77v3.08l-.42-1.48,3.28.64L168,72.24Zm2.46-.33V50.8l2.77,1.29V71.91Zm14.07.46-13.89-19.6,2.46-2.28L179,70.13l.17,2.13A9,9,0,0,1,176.51,72.37Zm5-21.88-.11,1.4a14.69,14.69,0,0,1-2.68.86l.46-1.65v3.08h-2.77V51.1l.38,1.48-2.92-.64.11-1.45Zm-2.33,21.77-2.77-1V50.8h2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M195.53,72.61q-5.62,0-8.65-2.79c-2-1.86-3-4.51-3-8a13,13,0,0,1,1.4-6.22,9.9,9.9,0,0,1,4-4.08,12.23,12.23,0,0,1,6.08-1.44,16.49,16.49,0,0,1,3.48.37,9,9,0,0,1,2.72,1c.12.84.2,1.7.24,2.55a17.13,17.13,0,0,1,0,2.39h-1.67l-2-4.66L200,53.43a11.3,11.3,0,0,0-5.05-1.21q-6.94,0-6.94,8.84,0,9.45,8,9.44a12.8,12.8,0,0,0,5.41-1.18l.63,2a9.73,9.73,0,0,1-2.81,1A17.91,17.91,0,0,1,195.53,72.61Zm2.93-6.76V62.77l.39,1.49-4-.61.11-1.45h8.63l-.13,1.63a7.39,7.39,0,0,1-1.86.63l.41-1.69v3.08Zm0,5.49V63.65H202V71.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M212.92,72.59a10.42,10.42,0,0,1-6.42-1.84,22.09,22.09,0,0,1-.22-5.43h1.6l2.38,5.51-1.72-1.64a9.84,9.84,0,0,0,4.88,1.34,4.59,4.59,0,0,0,3-.88,3.06,3.06,0,0,0,1-2.49,3,3,0,0,0-.81-2.17A6.22,6.22,0,0,0,214,63.58l-2.15-.68q-5.56-1.76-5.56-6.28a5.9,5.9,0,0,1,2.07-4.73A8.31,8.31,0,0,1,214,50.14a12.09,12.09,0,0,1,5.67,1.32,21.31,21.31,0,0,1,.22,4.76h-1.7l-1.93-4.48,2.11,1.8a10.61,10.61,0,0,0-4.88-1.34q-3.58,0-3.58,3.14a3.09,3.09,0,0,0,.87,2.27,6.91,6.91,0,0,0,2.8,1.49l2.15.68q5.43,1.71,5.43,6.18a5.89,5.89,0,0,1-2.22,4.84A9.2,9.2,0,0,1,212.92,72.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostSavings);
export default __webpack_public_path__ + "static/media/cost-savings.66b689f9bc3394a50e3afe2acf4c2680.svg";
export { ForwardRef as ReactComponent };